import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Points } from '@styles';

export const Burger = ({ isOpenMenu, onBurger, isDarkMode = false, locale = 'ru' }) => (
  <View onClick={onBurger} aria-label={locale === 'ru' ? 'Меню' : 'Menu'} aria-expanded={isOpenMenu}>
    <Line isOpenMenu={isOpenMenu} isDarkMode={isDarkMode} />
  </View>
);

const View = styled.button`
  ${Mixins.resetButton()};
  margin-left: 16px;
  position: relative;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;

  @media ${Points.tablet_landscape} {
    display: none;
  }

  &:before {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    top: -20px;
    left: -11px;
    border-radius: 8px;
  }
`;

const Line = styled.div`
  ${Mixins.transition('background-color')};
  width: 26.7px;
  position: relative;

  &:before,
  &:after {
    ${Mixins.transition('transform, background-color')};
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 0.09em;
    border-radius: 20px;
    background-color: ${(p) => (p.isDarkMode === true ? `${Colors.white}` : `${Colors.main_dark}`)};

    @media ${Points.tablet_landscape} {
      background-color: ${(p) => (p.isDarkMode === true ? `${Colors.white}` : `${Colors.main_dark}`)};
    }
  }

  &:before {
    transform: ${(p) => (p.isOpenMenu ? 'rotate(45deg)' : 'translateY(-4px)')};
  }

  &:after {
    transform: ${(p) => (p.isOpenMenu ? 'rotate(-45deg)' : 'translateY(4px)')};
  }
`;
